var _rect, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#4853EC",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-camera)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5755 20.9497H19.6258C18.1816 20.9497 17 22.1313 17 23.5755V32.4245C17 33.8687 18.1816 35.0504 19.6258 35.0504H30.5755C32.0197 35.0504 33.2013 33.8687 33.2013 32.4245V23.5755C33.2013 22.1051 32.0197 20.9497 30.5755 20.9497Z",
    fill: "#4853EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0563 22.3939C38.8988 22.4201 38.7412 22.4989 38.61 22.5777L34.5137 24.9409V31.0328L38.6362 33.396C39.3977 33.8424 40.343 33.5798 40.7894 32.8184C40.9207 32.582 40.9995 32.3194 40.9995 32.0306V23.9168C40.9995 22.9453 40.0804 22.1575 39.0563 22.3939Z",
    fill: "#4853EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-camera"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(17 16)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d62ac13e0b41f999ecccfa0a7196a525.camera.d62ac13e0b41f999ecccfa0a7196a525.svg";
export { ForwardRef as ReactComponent };